jQuery(function ($) {
    $.fn.is_on_screen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop() + 48,
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.bottm || viewport.top > bounds.bottom));

    };
    // $(window).on('load', function () {
        const carousel = $('.main-carousel');
        carousel.flickity({
            // options
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            setGallerySize: false,
            percentPosition: true,
            watchCSS: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: 4000,
            pauseAutoPlayOnHover: false,
            fade: true,
            selectedAttraction: 1,
            friction: 1,
            imagesLoaded: true,
            // lazyLoad: true
        });

        var flkty = carousel.data('flickity');
        // carousel.on( 'select.flickity', function() { $(this).flickity('playPlayer') })
        carousel.on('click', function () {
            carousel.flickity('next')
            carousel.flickity('playPlayer')
            $('#Ebene_1').removeClass('hide')
                    $('#Ebene_1_konture').addClass('hide')
        });
    
    
    
        const bildLoad = function() {
            var img = $('.lazy:first').attr('id')
            console.log($('.lazy'))
            img = $('#' + img)
            img.css({'opacity': '0'})
            img.attr('src', img.data('src'))
            // $('.random').packery('layout')
            
            img.removeClass('lazy')
            img.css({'opacity': '1'})
            $('.main-carousel').flickity('reloadCells')
            img.imagesLoaded().done(function(){
                if (img && img.attr('id') != $('img').last().attr('id')) {
                    bildLoad()
                }
            })
        }
        $('.first-img').imagesLoaded().done(function () {
            var imgs = $('.lazy')
            // var length = imgs.length / 5

            bildLoad()

            // lazy()
        });


        // var value = $(this).find('.is-selected').find('#menu_value').val();
        // if (value == 1) {
        //     $('.nav').addClass('white')
        //     $('.header-name').addClass('white')
        //     $('.logo').addClass('white')
        // } else {
        //     $('.nav').removeClass('white')
        //     $('.header-name').removeClass('white')
        //     $('.logo').removeClass('white') 
        // }
        carousel.on('change.flickity', function (event, index) {
            var value = $(this).find('.is-selected').find('#menu_value').val();
            if (value == 1) {
                $('.nav').addClass('white')
                $('.header-name').addClass('white')
                $('.logo').addClass('white')
            } else {
                $('.nav').removeClass('white')
                $('.header-name').removeClass('white')
                $('.logo').removeClass('white') 
            }

            // Hide Name on Second Slide
            // if (index == 1) {
            //     $('.header-name').addClass('hide')
            //     $('.logo').addClass('hide') 
            // }
        });
        

        setTimeout(function () {
            
            $('.header-name').addClass('hide')
            $('.logo').addClass('hide') 
        },3000)

        
        // Header Logo Hover & ACTION
        $('.logo').hover(function () {
            if ($(window).width() > 900) {
    
                $('#Ebene_1').toggleClass('hide')
                $('#Ebene_1_konture').toggleClass('hide')
            }
        })
        $('.logo').on('click', function () {

            // if ($(window).width() >= 900) {
                
                // var cells_total = flkty.cells.length
                // var random = Math.floor(Math.random() * cells_total) + 1;
                // var selected_cell = flkty.selectedIndex + 1;
                // if (random == selected_cell) {
                //     random = random + 1 
                // }
    
                // carousel.flickity( 'selectCell', random );
            //     if (flkty.player.state != 'paused') {
                    
            //         carousel.flickity('pausePlayer')
            //         $('#Ebene_1').removeClass('hide')
            //         $('#Ebene_1_konture').addClass('hide')
            //     } else {
                    
            //         carousel.flickity('unpausePlayer')
            //         $('#Ebene_1').addClass('hide')
            //         $('#Ebene_1_konture').removeClass('hide')
            //     }
            // } else {
                window.location.href = home.url + "/news"
            // }
        })

        // *News Click
        $('.news-cta').on('click', function () {
            $('#news').toggleClass('hide')
            $('#info').addClass('hide')
            hideShowMobileMenuIcons()
            $(this).toggleClass('focus')
            if (!$('#news').hasClass('hide')) {
                
                $('.nav').addClass('black')
            } else {
                
                $('.nav').removeClass('black')
            }
        })
        
        $('.close-news').on('click', function () {
            $('#news').toggleClass('hide')
            $('#info').addClass('hide')
            $('.news-cta').toggleClass('focus')
            if (!$('#news').hasClass('hide')) {
                
                $('.nav').addClass('black')
            } else {
                
                $('.nav').removeClass('black')
            }
        })

        // *Info Click
        $('.info-cta').on('click', function () {
            $('#info').toggleClass('hide')
            $('#news').addClass('hide')
            hideShowMobileMenuIcons()
            $(this).toggleClass('focus')
            $('.nav').toggleClass('black')
            if (!$('#info').hasClass('hide')) {
                
                $('.nav').addClass('black')
            } else {
                
                $('.nav').removeClass('black')
            }
        })
        
        $('.close-info').on('click', function () {
            $('#news').addClass('hide')
            $('#info').toggleClass('hide')
            $('.info-cta').toggleClass('focus')
            $('.nav').toggleClass('black')
            if (!$('#info').hasClass('hide')) {
                
                $('.nav').addClass('black')
            } else {
                
                $('.nav').removeClass('black')
            }
            
        })

        

    // });

    $('.mobile-svg').on('click', function () {
        hideShowMobileMenuIcons()
    })

    // *Initiate
    isTargetVisble()
    vh()
    $(window).on('resize', function () {
        vh()
    })
    $(window).on('scroll', function () {
        isTargetVisble()
        if ($(document).scrollTop() > 50) {
            $('.logo').addClass('hideMobile')
        } else {
            $('.logo').removeClass('hideMobile')
            
        }
    })

    // Hide Show Menu and icons mobile
    function hideShowMobileMenuIcons() {
        $('.mobile-options').toggleClass('hide')
        $('#mobile-svg').toggleClass('hide')
        $('#mobile-svg-kreuz').toggleClass('hide')
    }

    

    function isTargetVisble() {
        var retunVal = false;
        // console.log($('.carousel-cell').length)
        $('.carousel-cell').each(function() {
            if ($(this).is_on_screen()) {
                var icon_color = $(this).find('#menu_value').val()
                if (icon_color == 1) {
                    $('.logo').addClass('white')
                    $('.nav').addClass('white')
                    $('.header-name').addClass('white')
                } else {
                    $('.logo').removeClass('white') 
                    $('.nav').removeClass('white')
                    $('.header-name').removeClass('white')
                }
                retunVal = true;
                return false
            }
        });
        return retunVal;
    }
    
});

function vh() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}


